import paperless from '@views/paperless/index.vue'

export default {
  router: [
    {
      path: '/paperless',
      component: paperless,
      name: 'paperless',
      meta: {
        keepAlive: true
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/paperless/index.js